export const RoutePathNotFound = '/not-found';
export const RoutePathServerError = '/server-error';
export const RoutePathRegulatory = '/regulatory';
